(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pg-order-status"] && !Shopify.designMode) return;
  try {
    
(function () {
  function formatDate(value) {
    if (!value) return '';
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(date);
  }

  function iconSvg(code, state) {
    var normalized = String(code || '').toLowerCase();
    var path = 'M12 3 4 7v10l8 4 8-4V7l-8-4Zm0 2.2L17.6 8 12 10.8 6.4 8 12 5.2ZM6 9.6l5 2.5v6.2l-5-2.5V9.6Zm7 8.7v-6.2l5-2.5v6.2l-5 2.5Z';

    if (normalized.indexOf('photo') !== -1 || normalized.indexOf('information') !== -1) {
      path = 'M8.5 5 10 3h4l1.5 2H19a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3.5ZM12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z';
    } else if (normalized.indexOf('artwork') !== -1 || normalized.indexOf('artist') !== -1) {
      path = 'm4 16.5-.5 4 4-.5L18.7 8.8l-3.5-3.5L4 16.5Zm12.6-12.6 1.1-1.1a1.8 1.8 0 0 1 2.5 0l1 1a1.8 1.8 0 0 1 0 2.5l-1.1 1.1-3.5-3.5Z';
    } else if (normalized.indexOf('proof') !== -1) {
      path = 'M12 5c5 0 8.7 4.7 9.5 6-.8 1.3-4.5 6-9.5 6S3.3 12.3 2.5 11C3.3 9.7 7 5 12 5Zm0 2c-3.3 0-6.1 2.7-7.1 4 1 1.3 3.8 4 7.1 4s6.1-2.7 7.1-4c-1-1.3-3.8-4-7.1-4Zm0 1.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z';
    } else if (normalized.indexOf('revision') !== -1) {
      path = 'M7.1 7.1A7 7 0 0 1 19 12h2A9 9 0 0 0 5.7 5.7L3 3v6h6L7.1 7.1ZM16.9 16.9A7 7 0 0 1 5 12H3a9 9 0 0 0 15.3 6.3L21 21v-6h-6l1.9 1.9Z';
    } else if (normalized.indexOf('approved') !== -1) {
      path = 'm9.3 16.7-4-4 1.4-1.4 2.6 2.6 8-8 1.4 1.4-9.4 9.4Z';
    } else if (normalized.indexOf('production') !== -1 || normalized.indexOf('print') !== -1) {
      path = 'M7 3h10v4h1a3 3 0 0 1 3 3v6h-4v5H7v-5H3v-6a3 3 0 0 1 3-3h1V3Zm2 2v2h6V5H9Zm0 10v4h6v-4H9Zm9-6H6a1 1 0 0 0-1 1v4h2v-1h10v1h2v-4a1 1 0 0 0-1-1Z';
    } else if (normalized.indexOf('dispatch') !== -1 || normalized.indexOf('ship') !== -1) {
      path = 'M3 5h11v10h1.2a3 3 0 0 1 5.6 0H22v2h-1.2a3 3 0 0 1-5.6 0H9.8a3 3 0 0 1-5.6 0H3V5Zm2 2v8h.2a3 3 0 0 1 4.6 0H12V7H5Zm9 3h3.2l2.3 3H14v-3ZM7 15.5A1.5 1.5 0 1 0 7 18a1.5 1.5 0 0 0 0-3Zm11 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z';
    } else if (normalized.indexOf('delivered') !== -1) {
      path = 'm12 3 9 7-2 1.6V21h-5v-6h-4v6H5v-9.4L3 10l9-7Zm0 2.5L7 9.4V19h1v-6h8v6h1V9.4l-5-3.9Z';
    } else if (normalized.indexOf('cancel') !== -1 || normalized.indexOf('refund') !== -1 || normalized.indexOf('hold') !== -1) {
      path = 'M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18Zm0 2a7 7 0 0 0-5.4 11.4L16.4 6.6A7 7 0 0 0 12 5Zm5.4 2.6-9.8 9.8A7 7 0 0 0 17.4 7.6Z';
    }

    if (state === 'complete' && !normalized) {
      path = 'm9.3 16.7-4-4 1.4-1.4 2.6 2.6 8-8 1.4 1.4-9.4 9.4Z';
    }

    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + path + '"></path></svg>';
  }

  function stateLabel(state) {
    if (state === 'current') return 'Current';
    if (state === 'complete') return 'Complete';
    return 'Next';
  }

  var proofFrameUrls = new WeakMap();

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function clearProofFrame(frame) {
    var currentUrl = proofFrameUrls.get(frame);
    if (currentUrl) {
      URL.revokeObjectURL(currentUrl);
      proofFrameUrls.delete(frame);
    }
    frame.onload = null;
    frame.hidden = true;
    frame.removeAttribute('src');
    frame.style.removeProperty('height');
  }

  function buildProofFrameDocument(proofs) {
    var isSingle = proofs.length === 1;
    var rows = proofs.map(function (proof) {
      var label = isSingle ? '' : '<span class="proof-label">' + escapeHtml(proof.label || 'Artwork proof') + '</span>';
      var buttonText = isSingle ? 'View Your Proof' : 'View Proof';
      return '<div class="proof-row' + (isSingle ? ' proof-row--single' : '') + '">' +
        label +
        '<a class="proof-action" href="' + escapeHtml(proof.url) + '" target="_blank" rel="noopener noreferrer">' + buttonText + '</a>' +
      '</div>';
    }).join('');

    return '<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">' +
      '<style>' +
      'html,body{margin:0;padding:0;background:transparent;color:#1f2a3c;font-family:Poppins,Arial,sans-serif;overflow:hidden;}' +
      '*{box-sizing:border-box;}' +
      '.proof-list{display:grid;gap:10px;}' +
      '.proof-row{display:flex;align-items:center;justify-content:space-between;gap:16px;min-height:58px;padding:8px 10px 8px 16px;border:1px solid #efe7dd;border-radius:16px;background:#fbefef;}' +
      '.proof-row--single{justify-content:flex-start;min-height:52px;padding:0;border:0;background:transparent;}' +
      '.proof-label{min-width:0;font-size:13px;font-weight:800;overflow-wrap:anywhere;}' +
      '.proof-action,.proof-action:visited,.proof-action:hover,.proof-action:active{display:inline-flex;align-items:center;justify-content:center;min-height:48px;padding:0 22px;border:0;border-radius:999px;background:#d98c97;color:#fff;-webkit-text-fill-color:#fff;font-size:13px;font-weight:800;line-height:1.2;text-align:center;text-decoration:none;white-space:nowrap;}' +
      '.proof-action:hover{background:#c97884;}' +
      '.proof-action:focus-visible{outline:3px solid rgba(217,140,151,.35);outline-offset:2px;}' +
      '@media(max-width:520px){.proof-row{align-items:stretch;flex-direction:column;padding:12px;}.proof-row--single{padding:0}.proof-action{width:100%;white-space:normal;}}' +
      '</style></head><body><div class="proof-list">' + rows + '</div></body></html>';
  }

  function renderProofs(frame, proofs) {
    clearProofFrame(frame);
    if (!Array.isArray(proofs) || !proofs.length) return;

    var supportedStatuses = {
      ready_for_review: true,
      revision_requested: true,
      approved: true,
      completed: true
    };

    var safeProofs = proofs.filter(function (proof) {
      if (!proof || !supportedStatuses[String(proof.status || '').toLowerCase()]) return false;
      if (typeof proof.url !== 'string' || !proof.url) return false;

      try {
        return new URL(proof.url).protocol === 'https:';
      } catch (error) {
        return false;
      }
    });

    if (!safeProofs.length) return;

    var documentHtml = buildProofFrameDocument(safeProofs);
    var blobUrl = URL.createObjectURL(new Blob([documentHtml], { type: 'text/html' }));
    proofFrameUrls.set(frame, blobUrl);
    frame.style.height = safeProofs.length === 1 ? '56px' : (safeProofs.length * 96) + 'px';
    frame.onload = function () {
      var loadedUrl = proofFrameUrls.get(frame);
      if (loadedUrl === blobUrl) {
        URL.revokeObjectURL(blobUrl);
        proofFrameUrls.delete(frame);
      }
      frame.onload = null;
    };
    frame.src = blobUrl;
    frame.hidden = false;
  }

  function appendTimelineItem(list, item, currentCode) {
    var row = document.createElement('li');
    var state = String(item.state || item.status || '').toLowerCase();
    var code = item.code || '';

    if (!state && code && code === currentCode) state = 'current';
    if (state === 'completed') state = 'complete';
    if (state === 'active') state = 'current';
    if (item.complete === true) state = 'complete';
    if (item.current === true) state = 'current';
    if (!state) state = 'future';

    row.classList.add('is-' + state);

    var icon = document.createElement('span');
    icon.className = 'pg-order-status__timeline-icon';
    icon.innerHTML = iconSvg(code, state);
    row.appendChild(icon);

    var content = document.createElement('div');
    content.className = 'pg-order-status__timeline-content';

    var titleRow = document.createElement('div');
    titleRow.className = 'pg-order-status__timeline-title-row';

    var title = document.createElement('strong');
    title.className = 'pg-order-status__timeline-title';
    title.textContent = item.label || item.title || 'Order update';
    titleRow.appendChild(title);

    var badge = document.createElement('span');
    badge.className = 'pg-order-status__timeline-state';
    badge.textContent = stateLabel(state);
    titleRow.appendChild(badge);
    content.appendChild(titleRow);

    var dateValue = item.date || item.completed_at || item.updated_at;
    if (dateValue) {
      var date = document.createElement('div');
      date.className = 'pg-order-status__timeline-date';
      date.textContent = formatDate(dateValue);
      content.appendChild(date);
    }

    if (item.message) {
      var message = document.createElement('div');
      message.className = 'pg-order-status__timeline-message';
      message.textContent = item.message;
      content.appendChild(message);
    }

    row.appendChild(content);
    list.appendChild(row);
  }

  function init(section) {
    if (section.dataset.pgOrderStatusBound === 'true') return;
    section.dataset.pgOrderStatusBound = 'true';

    var endpoint = section.dataset.endpoint;
    var form = section.querySelector('[data-order-status-form]');
    var button = form.querySelector('button[type="submit"]');
    var buttonLabel = button.querySelector('[data-button-label]');
    var originalButtonLabel = buttonLabel.textContent;
    var message = section.querySelector('[data-order-status-message]');
    var result = section.querySelector('[data-order-status-result]');
    var label = section.querySelector('[data-order-status-label]');
    var number = section.querySelector('[data-order-status-number]');
    var summary = section.querySelector('[data-order-status-summary]');
    var proofs = section.querySelector('[data-order-status-proofs]');
    var updated = section.querySelector('[data-order-status-updated]');
    var timeline = section.querySelector('[data-order-status-timeline]');
    var tracking = section.querySelector('[data-order-status-tracking]');
    var trackingContent = tracking.querySelector('[data-tracking-content]');

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      message.textContent = '';
      clearProofFrame(proofs);
      result.hidden = true;

      if (!endpoint) {
        message.textContent = section.dataset.notConfigured;
        return;
      }

      var orderNumber = form.elements.order_number.value.trim();
      var verification = form.elements.verification.value.trim();
      if (!orderNumber || !verification) {
        message.textContent = 'Enter both your order number and email address or delivery postcode.';
        return;
      }

      button.disabled = true;
      buttonLabel.textContent = section.dataset.loading;

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_number: orderNumber, verification: verification }),
        credentials: 'omit'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Request failed');
          return response.json();
        })
        .then(function (payload) {
          var data = payload.order || payload;
          if (!data || payload.success === false) throw new Error('Order not found');

          var statusData = data.status || {};
          var statusLabel = statusData.label || data.status_label || data.stage_label || 'Order update';
          var statusMessage = statusData.message || data.status_message || data.message || '';
          var statusCode = statusData.code || data.status_code || data.stage_code || '';
          var updatedValue = statusData.updated_at || data.updated_at || data.last_updated_at;

          label.textContent = statusLabel;
          number.textContent = data.display_order_number || data.order_number || orderNumber;
          summary.textContent = statusMessage;
          summary.hidden = !statusMessage;
          renderProofs(proofs, data.proofs);
          updated.textContent = updatedValue ? section.dataset.lastUpdated + ' ' + formatDate(updatedValue) : '';
          updated.hidden = !updatedValue;

          timeline.textContent = '';
          var items = Array.isArray(data.timeline) ? data.timeline : [];
          if (!items.length) {
            items = [{ code: statusCode, label: statusLabel, state: 'current', updated_at: updatedValue, message: statusMessage }];
          }
          items.forEach(function (item) {
            appendTimelineItem(timeline, item, statusCode);
          });

          trackingContent.textContent = '';
          var trackingData = data.tracking || {};
          if (trackingData.url || trackingData.number || trackingData.carrier) {
            var details = document.createElement('p');
            details.textContent = [trackingData.carrier, trackingData.number].filter(Boolean).join(' · ');
            trackingContent.appendChild(details);

            if (trackingData.url) {
              var trackingLink = document.createElement('a');
              trackingLink.href = trackingData.url;
              trackingLink.target = '_blank';
              trackingLink.rel = 'noopener';
              trackingLink.textContent = 'Track delivery';
              trackingContent.appendChild(trackingLink);
            }
            tracking.hidden = false;
          } else {
            tracking.hidden = true;
          }

          message.textContent = '';
          result.hidden = false;
        })
        .catch(function () {
          message.textContent = section.dataset.genericError;
        })
        .finally(function () {
          button.disabled = false;
          buttonLabel.textContent = originalButtonLabel;
        });
    });
  }

  document.querySelectorAll('.pg-order-status').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.pg-order-status').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg-sale-bottom"]) return;
  try {
    
(function () {
  if (window.PGSaleBottomV2) return;
  window.PGSaleBottomV2 = true;

  function parseTarget(panel) {
    var dateStr = String(panel.getAttribute('data-target-date') || '').trim();
    var timeStr = String(panel.getAttribute('data-target-time') || '').trim();
    var timeZone = panel.getAttribute('data-time-zone') || 'Europe/London';
    var dateMatch = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    var timeMatch = timeStr.match(/^(\d{2}):(\d{2})$/);
    if (!dateMatch || !timeMatch) return NaN;

    var year = Number(dateMatch[1]);
    var month = Number(dateMatch[2]);
    var day = Number(dateMatch[3]);
    var hour = Number(timeMatch[1]);
    var minute = Number(timeMatch[2]);
    if (month < 1 || month > 12 || day < 1 || day > 31 || hour < 0 || hour > 23 || minute < 0 || minute > 59) return NaN;

    var desired = Date.UTC(year, month - 1, day, hour, minute, 0);
    var validation = new Date(desired);
    if (validation.getUTCFullYear() !== year || validation.getUTCMonth() !== month - 1 || validation.getUTCDate() !== day) return NaN;

    var guess = desired;
    var formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });

    for (var attempt = 0; attempt < 3; attempt += 1) {
      var parts = formatter.formatToParts(new Date(guess));
      var values = {};
      parts.forEach(function (part) {
        if (part.type !== 'literal') values[part.type] = part.value;
      });
      var rendered = Date.UTC(
        Number(values.year),
        Number(values.month) - 1,
        Number(values.day),
        Number(values.hour),
        Number(values.minute),
        Number(values.second)
      );
      var correction = desired - rendered;
      guess += correction;
      if (correction === 0) break;
    }
    return guess;
  }

  function visible(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      Number(style.opacity || 1) > 0.01 &&
      rect.width > 1 &&
      rect.height > 1;
  }

  function blockingInterfaceOpen() {
    if (!document.body) return false;
    if (document.body.classList.contains('fancybox-active') || document.body.classList.contains('blocked-scroll')) return true;
    var selectors = [
      '.cart-container.active_link .cart_content',
      '.fancybox-container:not(.fancybox-is-closing)',
      '[role="dialog"]',
      '.modal.is-active',
      '.popup.is-active',
      '.pg-cart-return-card',
      '.pg-photo-guide.is-open',
      '.pg-size-guide.is-open',
      '.site-overlay'
    ];
    return selectors.some(function (selector) {
      return Array.prototype.some.call(document.querySelectorAll(selector), visible);
    });
  }

  function stickyAtcOpen() {
    if (!window.matchMedia('(max-width: 768px)').matches) return false;
    var sticky = document.querySelector('[data-pg-sticky-atc].is-visible');
    return visible(sticky);
  }

  var chatClearanceFrame = null;
  var observedChatRoots = typeof WeakSet === 'function' ? new WeakSet() : null;

  function bottomClearanceHeight(element) {
    if (!visible(element)) return 0;
    var rect = element.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    if (!viewportHeight || rect.top >= viewportHeight || rect.bottom <= 0) return 0;
    if (rect.bottom < viewportHeight - 4) return 0;
    return Math.max(0, viewportHeight - Math.max(0, rect.top));
  }

  function chatClearanceAmount() {
    var sticky = document.querySelector('[data-pg-sticky-atc].is-visible');
    var height = bottomClearanceHeight(sticky);
    return height > 0 ? Math.ceil(height + 14) : 0;
  }

  function setChatTranslate(element, amount) {
    if (!element || !element.style) return;
    if (amount > 0) {
      element.style.setProperty('translate', '0 -' + amount + 'px', 'important');
      element.setAttribute('data-pg-chat-clearance', '1');
      return;
    }
    if (element.getAttribute('data-pg-chat-clearance') === '1') {
      element.style.removeProperty('translate');
      element.removeAttribute('data-pg-chat-clearance');
    }
  }

  function observeChatRoot(root) {
    if (!root || !window.MutationObserver) return;
    if (observedChatRoots && observedChatRoots.has(root)) return;
    if (observedChatRoots) observedChatRoots.add(root);
    var observer = new MutationObserver(scheduleChatClearance);
    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-expanded', 'open', 'isopen']
    });
  }

  function collectChatActivators(node, activators, depth) {
    if (!node || depth > 5) return;
    var root = node.shadowRoot || (node.nodeType === 11 ? node : null);
    if (!root || !root.querySelectorAll) return;

    observeChatRoot(root);

    [
      'button.activator',
      'button.chat-toggle',
      '.chat-app > button'
    ].forEach(function (selector) {
      Array.prototype.forEach.call(root.querySelectorAll(selector), function (button) {
        if (activators.indexOf(button) === -1) activators.push(button);
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('*'), function (child) {
      if (child.shadowRoot) collectChatActivators(child, activators, depth + 1);
    });
  }

  function refreshChatClearance() {
    chatClearanceFrame = null;
    var amount = chatClearanceAmount();
    var activators = [];
    var hosts = document.querySelectorAll('#ShopifyChat, #shopify-chat, shopify-chat, inbox-online-store-chat');

    Array.prototype.forEach.call(hosts, function (host) {
      collectChatActivators(host, activators, 0);
    });

    activators.forEach(function (button) {
      setChatTranslate(button, amount);
    });

    Array.prototype.forEach.call(document.querySelectorAll('iframe#dummy-chat-button-iframe, iframe#ShopifyChat'), function (frame) {
      var isOpen = String(frame.getAttribute('isopen') || '').toLowerCase() === 'true';
      setChatTranslate(frame, isOpen ? 0 : amount);
    });

    Array.prototype.forEach.call(hosts, function (host) {
      if (host.id === 'shopify-chat') return;
      var rect = host.getBoundingClientRect();
      var compactLauncher = rect.width > 0 && rect.height > 0 && rect.width <= 140 && rect.height <= 140;
      var hasActivator = activators.some(function (button) {
        return host.shadowRoot && host.shadowRoot.contains(button);
      });
      if (!hasActivator && compactLauncher) {
        setChatTranslate(host, amount);
      } else if (!compactLauncher) {
        setChatTranslate(host, 0);
      }
    });
  }

  function scheduleChatClearance() {
    if (chatClearanceFrame !== null) return;
    chatClearanceFrame = window.requestAnimationFrame(refreshChatClearance);
  }

  function storageGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (error) { return null; }
  }

  function storageSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (error) {}
  }

  function initPanel(panel) {
    if (!panel || panel.dataset.pgSaleBottomReady === '1') return;
    panel.dataset.pgSaleBottomReady = '1';

    var designMode = panel.getAttribute('data-design-mode') === 'true';
    var campaignKey = panel.getAttribute('data-campaign-key') || 'campaign';
    var dismissKey = 'pg_sale_bottom_dismissed_' + campaignKey;
    if (!designMode && storageGet(dismissKey) === '1') {
      panel.hidden = true;
      return;
    }

    var target = parseTarget(panel);
    if (!designMode && (!Number.isFinite(target) || target <= Date.now())) {
      panel.hidden = true;
      return;
    }

    var daysEl = panel.querySelector('[data-pg-sale-days]');
    var hoursEl = panel.querySelector('[data-pg-sale-hours]');
    var minutesEl = panel.querySelector('[data-pg-sale-minutes]');
    var secondsEl = panel.querySelector('[data-pg-sale-seconds]');
    var close = panel.querySelector('[data-pg-sale-bottom-close]');
    var visibilityFrame = null;
    var interval = null;

    function hideExpired() {
      if (designMode) {
        panel.hidden = false;
        panel.classList.remove('is-suppressed');
        panel.classList.add('is-ready');
        if (daysEl) daysEl.textContent = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minutesEl) minutesEl.textContent = '00';
        if (secondsEl) secondsEl.textContent = '00';
        if (interval) window.clearInterval(interval);
        interval = null;
        scheduleChatClearance();
        return;
      }
      panel.hidden = true;
      panel.classList.remove('is-ready', 'is-suppressed');
      if (interval) window.clearInterval(interval);
      interval = null;
      scheduleChatClearance();
    }

    function updateCountdown() {
      var distance = target - Date.now();
      if (!Number.isFinite(distance) || distance <= 0) {
        hideExpired();
        return;
      }
      var days = Math.floor(distance / 86400000);
      var hours = Math.floor((distance % 86400000) / 3600000);
      var minutes = Math.floor((distance % 3600000) / 60000);
      var seconds = Math.floor((distance % 60000) / 1000);
      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    function refreshVisibility() {
      visibilityFrame = null;
      if (designMode) {
        panel.hidden = false;
        panel.classList.remove('is-suppressed');
        panel.classList.add('is-ready');
        scheduleChatClearance();
        return;
      }
      if (panel.hidden) {
        scheduleChatClearance();
        return;
      }
      var suppressed = blockingInterfaceOpen() || stickyAtcOpen();
      panel.classList.toggle('is-suppressed', suppressed);
      if (!suppressed) panel.classList.add('is-ready');
      scheduleChatClearance();
    }

    function scheduleVisibility() {
      if (visibilityFrame !== null) return;
      visibilityFrame = window.requestAnimationFrame(refreshVisibility);
    }

    function scheduleUiRefresh() {
      scheduleVisibility();
      scheduleChatClearance();
    }

    if (close) {
      close.addEventListener('click', function () {
        if (designMode) return;
        storageSet(dismissKey, '1');
        panel.hidden = true;
        panel.classList.remove('is-ready', 'is-suppressed');
        if (interval) window.clearInterval(interval);
        interval = null;
        scheduleChatClearance();
      });
    }

    panel.hidden = false;
    updateCountdown();
    if (Number.isFinite(target) && target > Date.now()) {
      interval = window.setInterval(updateCountdown, 1000);
    }
    scheduleUiRefresh();

    window.addEventListener('resize', scheduleUiRefresh, { passive: true });
    window.addEventListener('scroll', scheduleUiRefresh, { passive: true });
    document.addEventListener('click', function () {
      window.setTimeout(scheduleUiRefresh, 0);
      window.setTimeout(scheduleUiRefresh, 120);
      window.setTimeout(scheduleUiRefresh, 420);
    }, true);
    document.addEventListener('cart:refresh', scheduleUiRefresh);

    if (window.MutationObserver && document.body) {
      var observer = new MutationObserver(scheduleUiRefresh);
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class', 'style', 'aria-hidden', 'open'],
        childList: true,
        subtree: true
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-pg-sale-bottom]').forEach(initPanel);
    [0, 300, 800, 1500, 3000, 6000].forEach(function (delay) {
      window.setTimeout(scheduleChatClearance, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
